import KitButton from "../kit/Button";
import React, { useState, useEffect } from 'react';
import { IoClose } from 'react-icons/io5';
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2';
import axiosInstance from '../../api/axiosInstance';
import { backendUrl } from '../../api/constants';
import TemplateCard from '../TemplateCard/TemplateCard';
import './TemplatePicker.css';

const TemplatePicker = ({ isOpen, onClose, onSelect }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchTemplates();
    }
  }, [isOpen]);

  const fetchTemplates = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axiosInstance.get(`${backendUrl}/influencer/templates`);
      if (data?.error) {
        setError(data.error);
      } else {
        setTemplates(data || []);
      }
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError('failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (template) => {
    const { _id, templateName, type, ...rest } = template;
    onSelect(rest);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="template-picker-overlay" onClick={onClose}>
      <div className="template-picker-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="template-picker-header">
          <div className="template-picker-title">
            <span>select a template</span>
          </div>
          <button className="template-picker-close" onClick={onClose}>
            <IoClose size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="template-picker-content">
          {loading ? (
            <div className="template-picker-loading">
              loading templates...
            </div>
          ) : error ? (
            <div className="template-picker-error">
              {error}
            </div>
          ) : templates.length === 0 ? (
            <div className="template-picker-empty">
              <div className="template-picker-empty-icon">
                <HiOutlineDocumentDuplicate size={48} />
              </div>
              <div className="template-picker-empty-text">
                no templates yet
              </div>
              <div className="template-picker-empty-hint">
                save your first template from the posting page using the menu options
              </div>
            </div>
          ) : (
            <div className="template-picker-list">
              {templates.map((template) => (
                <TemplateCard
                  key={template._id}
                  template={template}
                  variant="templatesPage"
                  onSelect={handleSelect}
                  compact
                />
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="template-picker-footer">
          <KitButton variant="secondary" onClick={onClose}>cancel</KitButton>
        </div>
      </div>
    </div>
  );
};

export default TemplatePicker;
